import { useEffect } from "react";

export const useAnalytics = ({
  appLoaded,
  email,
  isDemo,
  subscriptionTier,
}) => {
  useEffect(() => {
    if (!appLoaded || !window.gtag) return;
    if (isDemo) return;

    const tierLabel =
      subscriptionTier === 2 ? "pro" : subscriptionTier === 1 ? "plus" : "free";

    window.gtag("set", "user_properties", {
      account_type: "registered",
      subscription_tier: tierLabel,
    });

    if (email) {
      window.gtag("set", "user_id", email);
    }

    window.gtag("event", "page_view", {
      page_title: "Task Slate",
      page_path: "/app",
      account_type: "registered",
      subscription_tier: tierLabel,
    });

    if (!email) return;

    const loginKey = `analytics_login_tracked_${email}`;
    if (!sessionStorage.getItem(loginKey)) {
      window.gtag("event", "login", {
        method: "email",
        account_type: "registered",
        subscription_tier: tierLabel,
      });
      sessionStorage.setItem(loginKey, "true");
    }
  }, [appLoaded, email, isDemo, subscriptionTier]);
};
